// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2e9Lk","right":"styles_right__2Zm9z"};